import React from "react";
import ZenVerStackBar from "../ManagerDashboard/Common/Graph/ZenVerStackBar";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import {  Row, Col } from "antd";


class SbPlantRogItr extends React.Component {
  state = {
    ZenVerStackBar1:null,
    ZenVerStackBar2:null,
    loading: true,
    loginError: false,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
    console.log(this.props.urlData);
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData()
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab) => {
    liracrypt
      .get("/sb/dashboard/chartdata", this.props.urlData || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenVerStackBar1"] = resp["data"]["plantRogStatusDatewise"];
        respData["ZenVerStackBar2"] = resp["data"]["plantRogStatusLinewise"];
        
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (

        <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 10px",
                height: "450px",
                width: "98%"
              }}
            >
             <Row style={{   background: "#000000"}} >
            <Col span={12}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerStackBar
                  divId={"R2C1"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.ZenVerStackBar1.data}
                  config={this.state.ZenVerStackBar1.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col span={12}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerStackBar
                  divId={"R2C2"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.ZenVerStackBar2.data}
                  config={this.state.ZenVerStackBar2.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            
            
 
           
          </Row>



            </div>
            
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default SbPlantRogItr;